// extracted by mini-css-extract-plugin
export default {"container":"style_container__xsiNT","icon":"style_icon__O7thN","textContainer":"style_textContainer__1-r8d","text":"style_text__KP7eu"};